<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Part-Title-1">THE INTRODUCTION</p>
<p class="ORIM-Chapter-Opener-Paragraph">You spot them on the streets of the city and, increasingly, in the malls and parks of the suburbs. Sometimes they band together. Mostly, they walk alone. Bodybuilders. You know the kind. They strut like no others, holding their elbows wider than their shoulders, legs far apart. I know, I was one of them.</p>
<p class="ORIM-Body-Text">For four long years, I trained four hours a day, six days a week with them. I broke whole wheat bread with them. I filled my body with steroids alongside them. I lived with them. And, finally, I competed on stage against them.</p>
<p class="ORIM-Body-Text">The following is an account of my journey—what I did, what I saw, what I felt. Those in search of a steroid primer or an exercise manual are advised to look elsewhere; my purpose is different. Part ditty, part dirge, I sing of arms and the man, of weight rooms and muscle pits, of biceps and triceps, bench presses and low pulley rows, of young and old, woman and man, straining and hoisting iron to the boom box sound of Top 40 record stations in bodybuilding gyms across the land.</p>
<p class="ORIM-Body-Text">I sing of dreamers and addicts, rogues and visionaries. And I sing of my own solitary pilgrimage into this strange world. A world filled with wrist straps and ammonia, BIG Chewables and “the juice.” A world governed by a savage force that swallowed me whole from a bookstore in New York City, and did not relent until it had chewed me up and spit me out 80 pounds heavier and 3,000 miles later on a posing dais in Burbank, California. I was swabbed in posing oil and competition color, flexing with all my might, when I came to, a sadder and wiser man.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fussell_Muscle_4P_MD6.vue?4da3e2dc